import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setTableData } from './store/dataSlice'
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'
import Tooltip from 'components/Ui/Tooltip'
import { Modal, ConfirmationModal, Table, Upload } from 'components/Ui'
import { getApiData, deleteApiRecord, uploadApiProductsRecords } from 'services/ProductsService'
import { Success } from 'utils/alerts'
import useAuth from 'utils/hooks/useAuth'
import { Field, Form, Formik } from 'formik'
import { Button, Select } from 'components/Form'
import * as Yup from 'yup'
import { IntegrationOptions } from 'utils/options'
injectReducer('products', reducer)

const validationSchema = Yup.object().shape({
    file: Yup.string().required('file is required'),
    integration: Yup.string().required('integration is required'),
})

export default function Products() {
    const dispatch = useDispatch()
    const { checkPermission } = useAuth()
    const { data, tableData, loading } = useSelector(state => state.products.data)
    const { companyData, customersData } = useSelector(state => state.listData)
    const { company, customer } = useSelector(state => state.filterData)
    const [open, setOpen] = useState(false)

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
        company,
        customer,
    ])

    const fetchData = () => dispatch(getData({ ...tableData, company: company, customer: customer }))

    const filterData = () => {
        // const status = tableData?.selectedTab?.toLowerCase() || ''
        // const query = tableData.query?.toLowerCase() || ''
        const sort = tableData.sort || []

        // 1. Filter based on search query
        let filtered = data
            // ?.filter(item => {
            //     // Combine all values into a string to search across multiple columns
            //     const customerCode = customersData.find(c => c.id === item.customer)?.customer_code?.toLowerCase() || ''
            //     const companyCode = companyData.find(c => c.id === item.company)?.code?.toLowerCase() || ''
            //     const itemValues = Object.values(item).join(' ').toLowerCase() + ' ' + customerCode + ' ' + companyCode
            //     return itemValues.includes(query)
            // })
            // .filter(item => {
            //     if (company) {
            //         return item?.company?.toString() === company
            //     }
            //     return true
            // })
            // .filter(item => {
            //     if (customer) {
            //         return item?.customer?.toString() === customer
            //     }
            //     return true
            // })
            ?.filter(item => {
                // if (status) {
                //     return item?.['Process Flag']?.toLowerCase() === status
                // }
                return true
            })

        // 2. Sort based on tableData.sort array
        if (sort.length > 0) {
            sort.forEach(({ column, dir }) => {
                filtered = filtered.sort((a, b) => {
                    const aVal = a[column]
                    const bVal = b[column]

                    // Use localeCompare for strings, basic comparison for numbers
                    if (typeof aVal === 'string' && typeof bVal === 'string') {
                        return dir === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
                    } else {
                        return dir === 'asc' ? aVal - bVal : bVal - aVal
                    }
                })
            })
        }

        return filtered
    }

    const handleDelete = id => {
        deleteApiRecord(id)
            .then(() => {
                Success('Deleted Successfully!')
                fetchData()
            })
            .catch(error => console.log('Error: ', error))
    }

    const columns = useMemo(
        () => [
            {
                header: 'Action',
                className: 'px-4',
                hide: false,
                renderCell: row => {
                    return (
                        <div className="flex items-center gap-3">
                            {checkPermission('products', 'edit') ? (
                                <Tooltip title={'Edit'}>
                                    <Link to={`/maestro/products/${row.id}/edit`} className="hover:text-primary">
                                        <HiOutlinePencil size={20} />
                                    </Link>
                                </Tooltip>
                            ) : null}
                            {checkPermission('products', 'delete') ? (
                                <Tooltip title={'Delete'}>
                                    <ConfirmationModal
                                        message={'Are you sure you want to delete this record!'}
                                        onConfirm={() => {
                                            handleDelete(row.id)
                                        }}
                                    >
                                        <span className="hover:text-danger">
                                            <HiOutlineTrash size={20} />
                                        </span>
                                    </ConfirmationModal>
                                </Tooltip>
                            ) : null}
                        </div>
                    )
                },
            },
            // {
            //     field: 'customer',
            //     header: 'Company',
            //     className: 'min-w-[150px]',
            //     orderable: true,
            //     hide: false,
            // },
            {
                field: 'sku',
                header: 'Product',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'company',
                header: 'Company Code',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => companyData.find(item => item?.id === row?.company)?.code,
            },
            {
                field: 'customer',
                header: 'Customer Code',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => customersData.find(item => item?.id === row?.customer)?.customer_code,
            },
            {
                field: 'sku_descr1',
                header: 'Description',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'pack_id',
                header: 'Pack ID',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'sku_length',
                header: 'Length',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'sku_width',
                header: 'Width',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'sku_height',
                header: 'Height',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'cube',
                header: 'Cube',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'gross_weight',
                header: 'Weight',
                className: 'min-w-[200px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'processed_to_wms',
                header: 'Process flag',
                className: 'min-w-[200px]',
                orderable: true,
                hide: false,
            },
        ],
        // eslint-disable-next-line
        [
            tableData.sort,
            tableData.query,
            tableData.pageIndex,
            tableData.pageSize,
            tableData.selectedTab,
            tableData.checkBox,
            company,
            customer,
        ]
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Products</h2>
            </div>
            <Table
                loading={loading}
                upload={checkPermission('products', 'create')}
                download={true}
                datas={filterData()}
                columns={columns}
                file_name={'Products'}
                pagingData={tableData}
                onChange={e => dispatch(setTableData(e))}
                onUpload={() => setOpen(true)}
                csvDownloadApi={getApiData}
            />
            <Modal
                show={open}
                onClose={() => {
                    setOpen(false)
                }}
            >
                <div className="flex flex-col gap-1 m-3 sm:flex-row sm:items-center sm:justify-between">
                    <h2 className="font-semibold text-black text-title-md">{'Upload Product'}</h2>
                </div>
                <div className="flex flex-col items-center">
                    <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                        <div className="flex flex-col gap-3 p-6">
                            <Formik
                                initialValues={{ file: '', integration: '' }}
                                validationSchema={validationSchema}
                                onSubmit={values => {
                                    setOpen(false)
                                    uploadApiProductsRecords(values)
                                        .then(() => {
                                            Success('File Uploaded Successfully!')
                                            fetchData()
                                        })
                                        .catch(error => console.log('Error: ', error))
                                }}
                            >
                                {({ values, touched, errors }) => (
                                    <Form>
                                        <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                            <Field name="integration">
                                                {({ field, form }) => (
                                                    <Select
                                                        options={IntegrationOptions}
                                                        label="Integration"
                                                        size="sm"
                                                        placeholder="Select"
                                                        name="integration"
                                                        // className="md:col-span-2"
                                                        error={errors.integration && touched.integration}
                                                        message={errors.integration}
                                                        value={values?.integration}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="file">
                                                {({ field, form }) => (
                                                    <Upload
                                                        onFilesSelected={files => form.setFieldValue(field.name, files[0])}
                                                        error={errors.file && touched.file}
                                                        message={errors.file}
                                                    />
                                                )}
                                            </Field>
                                            <div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                                                <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">
                                                    Note: limited to 1 file per upload.
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="flex items-center justify-end gap-4 mt-3">
                                            <Button
                                                className="h-10 w-18 text-[#F05540] border border-[#F05540] dark:text-[#F05540] dark:border-[#F05540]"
                                                onClick={() => setOpen(false)}
                                                type="button"
                                            >
                                                Discard
                                            </Button>
                                            <Button
                                                type="submit"
                                                className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                            >
                                                Save
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
